import axios from "axios";

const SERVICES_URL = process.env.SERVICES_URL;
const API_URL = `${SERVICES_URL}/event`;

export const getMenuOptionsByPersonnel = (personnelMenuOptionsRequestDTO: any): Promise<any> =>
    axios
        .post(`${API_URL}/menuOptionsByPersonnel`, personnelMenuOptionsRequestDTO)
        .then(response => response.data);
